import moment from "moment";
import { auctionContractAddress, ethereum, loadAuctionContract, loadAuctionContractExternal } from "./blockchainInteractor";

export async function createAuction(addressNFTCollection, addressPaymentToken, nftId, initialBid,endAuction) {
    console.log( moment(endAuction*1000).format('YYYY-MM-DD'));
    const contract = loadAuctionContract();
    const txn = await contract.methods.createAuction(addressNFTCollection, addressPaymentToken, nftId, initialBid,endAuction).send({
        from: ethereum.selectedAddress,
        to: auctionContractAddress,
        gasLimit: 2000000,
    });
    return txn;
}

export async function bid(auctionIndex, newBid) {
    const contract = loadAuctionContract();
    const txn = await contract.methods.bid(auctionIndex, newBid).send({
        from: ethereum.selectedAddress,
        to: auctionContractAddress,
        gasLimit: 2000000,
    });
    return txn;
}

export async function claimNFT(auctionIndex) {
    const contract = loadAuctionContract();
    const txn = await contract.methods.claimNFT(auctionIndex).send({
        from: ethereum.selectedAddress,
        to: auctionContractAddress,
        gasLimit: 2000000,
    });
    return txn;
}

export async function claimToken(auctionIndex) {
    const contract = loadAuctionContract();
    const txn = await contract.methods.claimToken(auctionIndex).send({
        from: ethereum.selectedAddress,
        to: auctionContractAddress,
        gasLimit: 2000000,
    });
    return txn;
}

export async function refund(auctionIndex) {
    const contract = loadAuctionContract();
    const txn = await contract.methods.refund(auctionIndex).send({
        from: ethereum.selectedAddress,
        to: auctionContractAddress,
        gasLimit: 2000000,
    });
    return txn;
}

export async function getCurrentBid(auctionIndex) {
    const contract = loadAuctionContract();
    const txn = await contract.methods.getCurrentBid(auctionIndex).call();
    return txn;
}

export async function getCurrentBidOwner(auctionIndex) {
    const contract = loadAuctionContract();
    const txn = await contract.methods.getCurrentBidOwner(auctionIndex).call();
    return txn;
}

export async function isAuctionOpen(auctionIndex) {
    const contract = loadAuctionContract();
    const txn = await contract.methods.isOpen(auctionIndex).call();
    return txn;
}

export async function index() {
    const contract = loadAuctionContractExternal();
    const txn = await contract.methods.index().call();
    return txn;
}

export async function getAuctionInfo(index) {
    const contract = loadAuctionContract();
    const txn = await contract.methods.allAuctions(index).call();
    return txn;
}